const days90 = 90 * 24 * 60 * 60;
const clickParams = ['gclid', 'dclid', 'gbraid', 'wbraid'];
const campaignParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id'];

// Send the public SPA route and campaign fields. Never forward an arbitrary query or full referrer.
function pageFields(ads, publicHash) {
  const source = new URL(location.href);
  const page = new URL(location.pathname, location.origin);
  for (const key of ads ? [...campaignParams, ...clickParams] : campaignParams) {
    const value = source.searchParams.get(key);
    if (value && /^[a-z\d._~-]{1,120}$/i.test(value)) page.searchParams.set(key, value);
  }
  page.hash = publicHash();
  return {
    page_location: page.href,
    page_title: document.title,
    page_referrer: document.referrer ? new URL(document.referrer).origin : '',
  };
}

export function clearMeasurementStorage(analytics, ads) {
  const host = location.hostname;
  const domains = [''];
  if (!/^\d+\.\d+\.\d+\.\d+$/.test(host)) {
    const labels = host.split('.');
    while (labels.length > 1) {
      domains.push('; Domain=' + labels.join('.'));
      labels.shift();
    }
  }
  let cookies;
  try { cookies = document.cookie; } catch { return; }
  for (const item of cookies.split(';')) {
    const name = item.split('=')[0].trim();
    if ((!analytics && /^_ga(?:$|_)/.test(name)) || (!ads && /^_(gcl|gac)_/.test(name))) {
      for (const domain of domains) document.cookie = name + '=; Max-Age=0; Path=/' + domain;
    }
  }
  if (!ads) {
    try { localStorage.removeItem('_gcl_ls'); } catch { /* Storage may be disabled. */ }
  }
}

export function startMeasurement(ids, choice, publicHash) {
  const analytics = choice.analytics && ids.analytics;
  const ads = choice.ads && ids.ads;
  if (!analytics && !ads) return null;
  window.dataLayer = window.dataLayer || [];
  function tag() { window.dataLayer.push(arguments); }
  const denied = { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' };
  tag('consent', 'default', denied);
  tag('consent', 'update', {
    ...denied,
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_storage: ads ? 'granted' : 'denied',
    ad_user_data: ads ? 'granted' : 'denied',
  });
  tag('set', 'ads_data_redaction', true);
  tag('set', 'url_passthrough', false);
  tag('set', pageFields(ads, publicHash));
  tag('js', new Date());
  const parameters = {
    cookie_expires: days90,
    cookie_update: false,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  };
  if (analytics) tag('config', analytics, { ...parameters, send_page_view: false });
  if (ads) tag('config', ads, parameters);
  const script = document.createElement('script');
  script.async = true;
  script.referrerPolicy = 'no-referrer';
  script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(analytics || ads);
  document.head.append(script);

  function pageview() {
    const fields = pageFields(ads, publicHash);
    tag('set', fields);
    if (analytics) tag('event', 'page_view', { ...fields, send_to: analytics });
  }
  pageview();
  return {
    pageview,
    stop() {
      if (analytics) window['ga-disable-' + analytics] = true;
      if (ads) window['ga-disable-' + ads] = true;
      tag('consent', 'update', denied);
      script.remove();
    },
  };
}
